import React from 'react';

export default function OffersCard() {
  return (
    <div>
      {/* Decorative circles in background */}
      <div style={{
        position: 'absolute',
        top: '-42px',
        right: '-31px',
        width: '100px',
        height: '100px',
        borderRadius: '50%',
        background: 'rgba(255, 255, 255, 0.12)',
        border: '0px solid rgba(255, 255, 255, 0.15)'
      }} />
      
      <div style={{
        position: 'absolute',
        top: '-36px',
        right: '142px',
        width: '60px',
        height: '60px',
        borderRadius: '50%',
        background: 'rgba(255, 255, 255, 0.38)',
        border: '1px solid rgba(255, 255, 255, 0.20)'
      }} />
      
      <div style={{
        position: 'absolute',
        top: '-23px',
        right: '147px',
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        background: 'rgba(255, 255, 255, 0.20)',
        border: '0px solid rgba(255, 255, 255, 0.13)'
      }} />

      
    </div>
  );
}